import { render, staticRenderFns } from "./PrizeModal.vue?vue&type=template&id=68476b45&scoped=true&"
import script from "./PrizeModal.vue?vue&type=script&lang=js&"
export * from "./PrizeModal.vue?vue&type=script&lang=js&"
import style0 from "./PrizeModal.vue?vue&type=style&index=0&id=68476b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68476b45",
  null
  
)

export default component.exports